import React from 'react';

import { Alert } from 'antd';

function ExportWarning() {
  return (
    <Alert
      type='warning'
      showIcon
      className='mb-4!'
      message='Para garantir maior segurança, a exportação de relatórios via e-mail agora está restrita a endereços previamente autorizados. Se precisar adicionar um novo e-mail, acesse as configurações de controle de acesso.'
    />
  );
}

export default ExportWarning;
